<template>
  <div class="container-full mt-4">
    <div class="row">
      <div class="col-md-3">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Tanımlamalar</h5>
            <div class="list-group">
              <button
                v-for="item in menuItems"
                :key="item.key"
                type="button"
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                :class="{ active: selected === item.key }"
                @click="select(item.key)"
                :aria-current="selected === item.key"
              >
                <div>
                  <i :class="item.icon" class="me-2" v-if="item.icon"></i>
                  <span>{{ item.label }}</span>
                </div>
                <small v-if="item.badge" class="badge bg-secondary">{{ item.badge }}</small>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-9">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h5 class="card-title mb-0">{{ selected ? titleMap[selected] : 'İşlem yapmak için bir kategori seçiniz' }}</h5>
              <div>
                <b-button variant="success" size="sm" class="ms-2" v-if="selected === 'memnuniyet'" @click="$bvModal.show('memnuniyet-add-modal')">Yeni Soru Ekle</b-button>
                <b-button variant="primary" size="sm" class="ms-2" v-if="selected === 'kasa_banka'" @click="$bvModal.show('kasa-add-modal')">Yeni Kasa/Bankası Ekle</b-button>
              </div>
            </div>

            <div v-if="!selected">
              <p>Lütfen sol menüden bir kategori seçiniz.</p>
            </div>

            <!-- Kasa / Banka (kept similar) -->
            <div v-else-if="selected === 'kasa_banka'">
              <div class="mt-3">
                <h6 class="mb-2">Kasa / Banka Listesi</h6>
                <div v-for="typeKey in ['kasa','çek','cek','banka','havale']" :key="typeKey">
                  <div v-if="groupedPaymentTypes[typeKey] && groupedPaymentTypes[typeKey].length">
                    <h6 class="mt-3">{{ groupLabel(typeKey) }}</h6>
                    <ul class="list-group mb-2">
                      <li v-for="p in groupedPaymentTypes[typeKey]" :key="p.id" class="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <strong :class="p.visible ? '' : 'text-muted'">{{ p.title }}</strong>
                          <div class="text-muted small">Type: {{ p.type }} · Döviz: {{ p.currency || 'TRY' }}</div>
                        </div>
                        <div>
                          <button class="btn btn-sm me-2" :class="p.visible ? 'btn-outline-danger' : 'btn-outline-success'" @click="togglePaymentTypeById(p.id)">{{ p.visible ? 'Pasife Al' : 'Aktife Al' }}</button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- SMS -->
            <div v-else-if="selected === 'sms'">
              <div class="mt-3">
                  <b-form @submit.prevent="savePrimarySms">
                  <div class="row mb-3 align-items-end">
                    <div class="col-md-6">
                      <label class="form-label">Birincil SMS Tercihi</label>
                      <select class="form-control form-select" v-model="primarySelection">
                        <option v-for="p in smsProvidersList" :key="p.id" :value="p.value">{{ p.label || p.value }}</option>
                      </select>
                    </div>
                    <div class="col-md-6 text-end">
                      <b-button variant="primary" type="submit">Kaydet</b-button>
                      <b-button variant="secondary" class="ms-2" @click="fetchSmsSettings">Yenile</b-button>
                    </div>
                  </div>
                  </b-form>


                </div>
            </div>

            <!-- Memnuniyet -->
            <div v-else-if="selected === 'memnuniyet'">
              <div class="mt-3">
                <h6 class="mb-2">Anket Başlıkları</h6>
                <ul class="list-group">
                  <li v-for="(q, idx) in survey.questions" :key="idx" class="list-group-item d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <span :class="q.deleted_at ? 'text-muted' : ''">{{ q.content_tr || q.title || q.content }}</span>
                      <small v-if="q.deleted_at" class="badge bg-warning ms-3">Pasif</small>
                    </div>
                    <div>
                      <button class="btn btn-sm me-2" :class="q.deleted_at ? 'btn-outline-success' : 'btn-outline-danger'" @click="toggleQuestion(idx)">{{ q.deleted_at ? 'Aktife Al' : 'Pasife Al' }}</button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Ayarlar (only visible to authorized users) -->
            <div v-else-if="selected === 'ayarlar' && canEditLimits">
              <div class="mt-3">
                <div class="mb-3">
                  <label class="form-label d-block">Borcu bu limitin üzeri olursa dondur</label>
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div class="input-group">
                        <input type="number" class="form-control" v-model.number="limitSettings.limit_value" :disabled="!limitSettings.freeze_under_limit" />
                        <span class="input-group-text">TL</span>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="limitSettings.freeze_under_limit" id="freezeSwitch">
                        <label class="form-check-label" for="freezeSwitch">Aktif</label>
                      </div>
                    </div>
                    <div class="col-md-3 text-end">
                      <button class="btn btn-primary" @click="saveLimitSettings">Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="card1" v-if="selected === 'sms'">
            <Sms />
        </div>
      </div>
    </div>

    <!-- Memnuniyet modal -->
    <b-modal id="memnuniyet-add-modal" title="Yeni Memnuniyet Sorusu Ekle" hide-footer size="lg" centered>
      <b-form @submit.prevent="addQuestion">
        <b-form-group label="Soru (TR)" label-for="q_tr">
          <b-form-textarea id="q_tr" v-model.trim="newQuestion.content_tr" rows="3" required placeholder="Soru metnini girin"></b-form-textarea>
        </b-form-group>

        <b-form-group label="Soru (EN)" label-for="q_en" class="mt-2">
          <b-form-textarea id="q_en" v-model.trim="newQuestion.content_en" rows="2" placeholder="(Opsiyonel) English translation"></b-form-textarea>
        </b-form-group>

        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" class="me-2" @click="$bvModal.hide('memnuniyet-add-modal')">İptal</b-button>
          <b-button type="submit" variant="primary">Ekle</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="kasa-add-modal" title="Yeni Kasa/Banka Ekle" hide-footer centered>
      <b-form @submit.prevent="addPaymentType">
        <b-form-group label="Tip" label-for="pt_type">
          <select id="pt_type" class="form-select" v-model="newPayment.type">
            <option value="kasa">Nakit (Kasa)</option>
            <option value="banka">Kredi Kartı</option>
            <option value="havale">Havale</option>
            <option value="cek">Çek</option>
          </select>
        </b-form-group>
        <b-form-group label="Döviz Cinsi" label-for="pt_currency" class="mt-2">
          <select id="pt_currency" class="form-select" v-model="newPayment.currency">
            <option value="TRY">TL</option>
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
          </select>
        </b-form-group>
        <b-form-group label="Tanım Adı" label-for="pt_title" class="mt-2">
          <b-form-input id="pt_title" v-model.trim="newPayment.title" required placeholder="Örn: USD Kasa"></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" class="me-2" @click="$bvModal.hide('kasa-add-modal')">İptal</b-button>
          <b-button type="submit" variant="primary">Ekle</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { notify } from '@/helpers/notify'
import Sms from './sms.vue'

export default {
  name: 'Tanimlamalar',
  components: { Sms },
  data() {
    return {
      selected: null,
      menuItems: [
        { key: 'sms', label: 'SMS Ayarları' },
        { key: 'kasa_banka', label: 'Kasa / Banka' },
        { key: 'memnuniyet', label: 'Memnuniyet Anketi' }
      ],
      limitSettings: { freeze_under_limit: false, limit_value: 0 },
      titleMap: { sms: 'SMS Ayarları', kasa_banka: 'Kasa / Banka', memnuniyet: 'Memnuniyet Anketi' },
      survey: { title: 'Müşteri Memnuniyeti Anketi', active: true, q1: 'Genel memnuniyetiniz nasıl?', questions: [] },
      newQuestion: { content_tr: '', content_en: '' },
      newPayment: { title: '', type: 'kasa', currency: 'TRY' },
      paymentTypes: [],
      smsForm: { content: '' },
      smsProvidersList: [],
      primarySelection: ''
    }
  },
  computed: {
    groupedPaymentTypes() {
      const groups = {};
      (this.paymentTypes || []).forEach(p => {
        const t = (p.type || 'other').toString();
        if (!groups[t]) groups[t] = [];
        groups[t].push(p);
      });
      return groups;
    },
    otherGroupedPaymentTypes() {
      const skip = ['kasa', 'çek', 'cek', 'banka', 'havale'];
      return Object.keys(this.groupedPaymentTypes)
        .filter(t => !skip.includes(t) && (this.groupedPaymentTypes[t] && this.groupedPaymentTypes[t].length))
        .map(t => ({ type: t, items: this.groupedPaymentTypes[t] }));
    },
    canEditLimits(){
      try{ const userdata = JSON.parse(localStorage.getItem('userdata')) || {}; return userdata.role_name === 'admin' && userdata.group_mask == 1 }catch(e){ return false }
    }
  },
  mounted() {
    try{
      const userdata = JSON.parse(localStorage.getItem('userdata')) || {};
      if(userdata.role_name === 'admin' && userdata.group_mask == 1){
        this.menuItems.splice(0,0, { key: 'ayarlar', label: 'Ayarlar' });
        this.titleMap.ayarlar = 'Ayarlar';
        // if user can edit limits, proactively fetch settings to reflect UI state
        this.fetchLimitSettings();
      }
    }catch(e){/* ignore */}
  },
  methods: {
    fetchSmsSettings(){
      this.$http.get('/settings/sms')
        .then(resp => {
          const data = resp.data || {};
          if (Array.isArray(data.providers) && data.providers.length){
            this.smsProvidersList = data.providers.map((p, idx) => ({ id: p.id || (Date.now()+idx), value: p.value||p.provider||'', label: p.label||p.value||p.provider||'', username: p.username||'', password: p.password||'', org: p.org||'', is_primary: !!p.is_primary }));
            this.smsForm.content = data.content || data.message || '';
            if(!this.smsProvidersList.find(p=>p.is_primary)) this.smsProvidersList[0].is_primary = true;
            const primary = this.smsProvidersList.find(p=>p.is_primary) || this.smsProvidersList[0];
            this.primarySelection = primary ? (primary.value||primary.provider||'') : '';
          } else {
            const vals = data.sms || data || {};
            this.smsProvidersList = [{ id: Date.now(), value: vals.provider||vals.sms_provider||'', label: vals.provider||vals.sms_provider||'', username: vals.username||vals.sms_username||vals.user||'', password: vals.password||vals.sms_password||vals.pass||'', org: vals.org||vals.sms_org||vals.sender||'', is_primary: true }];
            this.smsForm.content = vals.content||vals.sms_content||vals.message||'';
          }
        })
        .catch(()=>{ this.smsProvidersList = []; this.smsForm.content = ''; this.primarySelection = '' });
    },
    savePrimarySms(){
      this.smsProvidersList.forEach(p=>p.is_primary = (p.value === this.primarySelection));
      const providers = (this.smsProvidersList || []).map(p=>({ value:p.value, label:p.label, username:p.username, password:p.password, org:p.org, is_primary:!!p.is_primary }));
      const primary = providers.find(p=>p.is_primary) || providers[0] || {};
      const payload = Object.assign({ providers: providers, content: this.smsForm.content }, { provider: primary.value||'', username: primary.username||'', password: primary.password||'', org: primary.org||'' });
      this.$http.put('/settings/sms', payload).then(()=>{ notify.success('Birincil SMS tercihi kaydedildi.'); this.fetchSmsSettings() }).catch(()=>{ notify.error('Kaydetme başarısız.') });
    },
    select(key){ this.selected = key; if(key==='memnuniyet') this.fetchQuestions(); if(key==='kasa_banka') this.fetchPaymentTypes(); if(key==='sms') this.fetchSmsSettings(); if(key==='ayarlar') this.fetchLimitSettings(); },
    fetchLimitSettings(){
      this.$http.get('/settings/extra')
        .then(resp => {
          const data = resp.data || {};
          this.limitSettings.freeze_under_limit = data.freeze_under_limit === true || data.freeze_under_limit === 'true' || data.freeze_under_limit === 1 || data.freeze_under_limit === '1';
          this.limitSettings.limit_value = data.limit_value || 0;

          // If the settings menu exists and nothing is selected, mark it selected only when settings indicate active freeze or non-zero limit
          const hasAyar = (this.menuItems || []).some(i => i.key === 'ayarlar');
          if (hasAyar && !this.selected && (this.limitSettings.freeze_under_limit || (this.limitSettings.limit_value && Number(this.limitSettings.limit_value) > 0))) {
            this.selected = 'ayarlar';
          }
        })
        .catch(()=>{ this.limitSettings = { freeze_under_limit:false, limit_value:0 } })
    },

    saveLimitSettings(){
      const userdata = JSON.parse(localStorage.getItem('userdata'))||{};
      if(!(userdata.role_name === 'admin' && userdata.group_mask == 1)) return notify.error('Yetkiniz yok');
      const payload = { freeze_under_limit: { val: this.limitSettings.freeze_under_limit ? 'true' : 'false' }, limit_value: { val: String(this.limitSettings.limit_value || 0) } };
      this.$http.put('/settings/extra', payload).then(()=>{ notify.success('Kaydedildi'); this.fetchLimitSettings() }).catch(()=>{ notify.error('Kaydetme hatası') })
    },
    fetchQuestions(){ this.$http.post('/survey/get-questions',{}).then(res=>{ this.survey.questions = res.data||[] }).catch(()=>{ this.survey.questions = [] }) },
    addQuestion(){ if(!this.newQuestion || !this.newQuestion.content_tr) return; this.$http.post('/survey/add-question', this.newQuestion).then(res=>{ const added = res.data; if(added && added.id){ this.survey.questions.unshift(added); this.newQuestion.content_tr=''; this.newQuestion.content_en=''; this.$bvModal.hide('memnuniyet-add-modal'); notify.success('Yeni soru eklendi.') } }).catch(()=>{ notify.error('Ekleme başarısız.') }) },
    fetchPaymentTypes(){ this.$http.post('/safebank/types',{}).then(res=>{ this.paymentTypes = res.data || [] }).catch(()=>{ this.paymentTypes = [] }) },
    groupLabel(type){ const map = { 'kasa': 'Nakit', 'çek': 'Çek Bankası', 'cek': 'Çek Bankası', 'banka': 'Kredi Kartı', 'havale': 'Havale Bankası' }; return map[type] || (type? type.toString() : 'Diğer') },
    togglePaymentTypeById(id){ const idx = this.paymentTypes.findIndex(p=>p.id===id); if(idx===-1) return; const p = this.paymentTypes[idx]; if(!p||!p.id) return; const action = p.visible ? 'pasife almak' : 'aktifleştirmek'; if(!confirm(`Bu kaydı ${action} istediğinize emin misiniz?`)) return; this.$http.post('/safebank/toggle-visible',{ id: p.id }).then(res=>{ const data = res.data || {}; if(data.row){ this.paymentTypes.splice(idx,1,data.row); notify.success(data.message || 'İşlem tamamlandı.') } else this.fetchPaymentTypes() }).catch(()=>{ notify.error('İşlem başarısız.') }) },
    addPaymentType(){ if(!this.newPayment || !this.newPayment.title){ notify.warn('İsim giriniz.'); return } if(!this.newPayment.type){ notify.warn('Tip seçiniz.'); return } this.$http.post('/safebank/store',{ title:this.newPayment.title, type:this.newPayment.type, currency:this.newPayment.currency || 'TRY' }).then(()=>{ this.fetchPaymentTypes(); this.newPayment={ title:'', type:'kasa', currency:'TRY' }; this.$bvModal.hide('kasa-add-modal'); notify.success('Kayıt eklendi.') }).catch(()=>{ notify.error('Ekleme başarısız.') }) },
    toggleQuestion(idx){ const q = this.survey.questions[idx]; if(!q||!q.id) return; const action = q.deleted_at ? 'aktifleştirmek' : 'pasife almak'; if(!confirm(`Bu soruyu ${action} istediğinize emin misiniz?`)) return; this.$http.post('/survey/delete-question',{ id: q.id }).then(res=>{ const data = res.data||{}; if(data.row){ this.survey.questions.splice(idx,1,data.row); notify.success(data.message || 'İşlem tamamlandı.') } else { notify.success(data.message || 'İşlem tamamlandı.'); this.fetchQuestions() } }).catch(()=>{ notify.error('İşlem başarısız.') }) },
    addSmsProvider(){ this.smsProvidersList.push({ id: Date.now()+Math.random(), value:'', label:'', username:'', password:'', org:'', is_primary:false }) },
    removeSmsProvider(idx){ if(!confirm('Bu SMS sağlayıcısını silmek istediğinize emin misiniz?')) return; const wasPrimary = !!this.smsProvidersList[idx].is_primary; this.smsProvidersList.splice(idx,1); if(wasPrimary && this.smsProvidersList.length) this.smsProvidersList[0].is_primary = true },
    setPrimaryProvider(idx){ this.smsProvidersList.forEach((p,i)=>p.is_primary = (i===idx)) },
    saveSurvey(){ notify.success('Anket kaydedildi.') }
  }
}
</script>

<style scoped>
.card { border: 1px solid #e9ecef; }
</style>
